import * as z from "zod"

export const DBBrandGroupModel = z.object({
  id: z.number().int(),
  name: z.string(),
})
